import { BILL_PAYER_INFO_API } from 'constants/AppConstants';

export default async () => {
  try {
    const response = await fetch(`${BILL_PAYER_INFO_API}`);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
